import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// 2023-10-24 GK - Creates a thunk to get the crypto account
// Redux Thunk is middleware that allows you to return functions, rather than just actions, within Redux. This allows for delayed actions, including working with promises. One of the main use cases for this middleware is for handling actions that might not be synchronous, for example, using axios to send a GET request
export const getCryptoAccount = createAsyncThunk('cryptoAccount/getCryptoAccount', 
    async () => {
        const response = await axios.get('/api/crypto-account');

        return response.data;
});